var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotifications28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#notifications_28-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m5.188 16.236-.354 2.45c-.173 1.203-.26 1.805-.06 2.217a1.5 1.5 0 0 0 .863.767c.433.149 1.02-.008 2.194-.323l15.185-4.069c1.174-.314 1.76-.471 2.062-.817a1.5 1.5 0 0 0 .364-1.096c-.034-.457-.41-.934-1.161-1.89L22.75 11.53c-.166-.21-.248-.315-.325-.423a6.003 6.003 0 0 1-.848-1.691c-.04-.126-.074-.256-.143-.514-1.424-5.312-5.84-8.27-10.67-6.976C5.936 3.22 3.59 7.99 5.015 13.302c.068.258.103.387.132.517a6 6 0 0 1 .112 1.888c-.013.132-.032.264-.07.529Zm5.216 7.527 7.728-2.07s.07 4.122-3.312 5.028c-3.38.906-4.416-2.958-4.416-2.958Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "notifications_28-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications28);
export default __webpack_public_path__ + "static/media/notifications_28.9c590d62.svg";
export { ForwardRef as ReactComponent };